export default {
  offers: '/workshop/offers',
  compareOffers: '/workshop/compare-offers/:transactionId',
};
